import { createFileRoute, notFound } from "@tanstack/react-router";

import { getAuthorPage } from "@/content/blog";
import {
  CONTENT_CACHE_CONTROL,
  CONTENT_NOT_FOUND_CACHE_CONTROL,
} from "@/content/cachePolicy";
import AuthorPage from "./-components/AuthorPage";
import { NotFoundPage } from "@/components/landing/LandingNotFound";

/**
 * `/author/:slug`, the nine pages the published sitemap carries.
 *
 * An author nobody has written under throws rather than rendering an empty
 * grid, so a retired byline answers 404 the way the published site does.
 */
export const Route = createFileRoute("/author/$slug")({
  loader: async ({ params }) => {
    const page = await getAuthorPage({ data: params.slug });
    if (!page) {
      throw notFound();
    }
    return page;
  },
  headers: ({ loaderData }) => ({
    "Cache-Control": loaderData
      ? CONTENT_CACHE_CONTROL
      : CONTENT_NOT_FOUND_CACHE_CONTROL,
  }),
  component: AuthorRoute,
  notFoundComponent: NotFoundPage,
});

function AuthorRoute() {
  const { author, posts } = Route.useLoaderData();
  return <AuthorPage author={author} posts={posts} />;
}
